module.exports = __webpack_public_path__ + "img/easter_bonnet.27085945.jpg";